<template>
  <div class="home-mp">
    <div class="header">
      <router-link to="/m/me" tag="a" class="avatar">
        <img :src="userinfo.avatarUrl" />
      </router-link>
      <div class="teacher-name">{{ userinfo.name }}</div>
      <router-link to="/m/booking" tag="a" class="booking-btn">
        <span class="booking-icon"></span>
        <span>{{ $t("lang.openingTime") }}</span>
      </router-link>
    </div>
    <div class="card scheduled-count-card">
      <div class="all-scheduled">
        <span class="text">{{ $t('lang.pendingCourse') }}</span>
        <span class="count">{{ allCourseCount }}</span>
      </div>
      <div class="details-count">
        <div class="count-1v1">
          <span class="count">{{ scheduledCount.bookedNum + scheduledCount.auditionClassNum }}</span>
          <span class="text">1v1</span>
        </div>
        <div class="count-1vn">
          <span class="count">{{ scheduledCount.teamNum }}</span>
          <span class="text">{{ $t('lang.miniClass') }}</span>
        </div>
        <div class="count-open">
          <span class="count">{{ scheduledCount.openClassNum }}</span>
          <span class="text">{{ $t('lang.openClass') }}</span>
        </div>
      </div>
    </div>
    <div v-if="comingSoon" class="card last-course-card">
      <div class="title">{{ $t('lang.recentCourse') }}</div>
      <router-link class="course-info" tag="a" :to="{ path:'/m/course', query: { lessonId: comingSoon.id, roomUrl: comingSoon.roomUrl }}">
        <div v-if="stuSimpInfo[0].avatar" class="stu-avatar">
          <img :src="stuSimpInfo[0].avatar" />
        </div>
        <div class="course">
          <div class="course-title">{{ comingSoon.courseName }}</div>
          <div class="details">
            <span class="time">{{
              language === 'en' ? $utils.formatLocalTimeYYYYMMDDdddHHmm(comingSoon.localStartTime, timeZone) :  $utils.formatCNTimeYYYYMMDDdddHHmm(comingSoon.localStartTime, timeZone)
            }}</span>
            <span v-if="comingSoon.courseType === 0" class="label">1v1</span>
            <span v-if="comingSoon.courseType === 2" class="label label-1vn">1vN</span>
            <span v-if="comingSoon.courseType === 1" class="label label-open">{{ $t('lang.openClass') }}</span>
          </div>
        </div>
      </router-link>
    </div>
    <el-tabs class="course-tab" v-model="isfinished" @tab-click="handleTabs">
      <el-tab-pane :label="$t('lang.pendingCourses')" name="0">
      </el-tab-pane>
      <el-tab-pane :label="$t('lang.takenCourse')" name="1">
      </el-tab-pane>
    </el-tabs>
    <div class="card course-card">
      <div class="time-display">
        {{$t('lang.bookPage6')}}: {{timeZone}}
        <button @click="handleTZClick" class="wrong-timezone">{{$t('lang.wrongTimezone')}}<i class="el-icon-question"></i></button>
      </div>
      <div class="courses-list" v-if="isfinished === '0'">
        <div class="no-course" v-if="unfinishedCourses.length === 0">
          <div class="no-course-img">
            <img src="~assets/images/db_kk@2x.png">
          </div>
          <p class="text">{{ $t('lang.noPendingCourses1') }}<br>{{ $t('lang.noPendingCourses2') }}</p>
          <router-link to="/m/booking" tag="a" class="booking-btn">{{ $t("lang.openingTime") }}</router-link>
        </div>
        <div
          v-for="course in unfinishedCourses"
          :key="course.id"
          class="courses"
        >
          <div class="tag" v-if="course.tag">{{ language === 'en' ? $utils.formatENTimeMMDDddd(course.startTime, timeZone) : $utils.formatCNTimeMMDDddd(course.startTime, timeZone) }}</div>
          <router-link tag="a" :to="{ path:'/m/course', query: { lessonId: course.id, roomUrl: course.lessonInfo2.roomUrl } }" class="courses-container border-btm">
            <span v-if="course.courseType === 'MIN'" class="label">1v1</span>
            <span v-if="course.courseType === 'TEAM'" class="label label-1vn">1vN</span>
            <span v-if="course.courseType === 'OPEN'" class="label label-open">{{ $t('lang.openClass') }}</span>
            <div class="course-info">
              <div class="course-name">{{ course.name }}</div>
              <div class="time">{{ language === 'en' ? $utils.formatLocalTimeYYYYMMDDdddHHmm(course.startTime, timeZone) :  $utils. formatCNTimeYYYYMMDDdddHHmm(course.startTime, timeZone) }}</div>
            </div>
            <div class="arrow"></div>
          </router-link>
        </div>
      </div>
      <div class="courses-list" v-if="isfinished === '1'">
        <div
          v-for="course in finishedCourses"
          :key="course.id"
          class="courses"
        >
          <div class="tag" v-if="course.tag">{{ language === 'en' ? $utils.formatENTimeMMDDddd(course.startTime, timeZone) : $utils.formatCNTimeMMDDddd(course.startTime, timeZone) }}</div>
          <router-link tag="a" :to="{ path:'/m/course', query: { lessonId: course.id, roomUrl: course.lessonInfo2.roomUrl } }" class="courses-container border-btm">
            <span v-if="course.courseType === 'MIN'" class="label">1v1</span>
            <span v-if="course.courseType === 'TEAM'" class="label label-1vn">1vN</span>
            <span v-if="course.courseType === 'OPEN'" class="label label-open">{{ $t('lang.openClass') }}</span>
            <div class="course-info">
              <div class="course-name">{{ course.name }}</div>
              <div class="time">
                {{ language === 'en' ? $utils.formatLocalTimeYYYYMMDDdddHHmm(course.startTime, timeZone) :  $utils. formatCNTimeYYYYMMDDdddHHmm(course.startTime, timeZone) }}
              </div>
            </div>
            <div class="arrow"></div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="loader" v-if="isfinished === '0'">{{ unfinishedListLoad  ? $t('lang.loadMore') : $t('lang.noMore') }}</div>
    <div class="loader" v-if="isfinished === '1'">{{ finishedListLoad  ? $t('lang.loadMore') : $t('lang.noMore') }}</div>
    <el-dialog
      class="timzone-dialog"
      :show-close="false"
      :center="true"
      :width="'86vw'"
      :top="'25vh'"
      :visible.sync="timezoneDialogVisible"
    >
      <div class="tip">{{ $t("lang.selectTZ") }}</div>
      <label class="tz-label" for="tz">UTC：</label>
      <select class="tz-select" style="width: 100%" v-model="tz" name="tz" id="tz">
        <option disabled value="">{{ $t("lang.select") }}</option>
        <option class="tz-opt" v-for="(tz, index) in timeZones" :key="index" :label="tz.text" :value="tz.utc">{{ tz.text }}</option>
      </select>
      <label class="tz-label" for="tz">{{ $t("lang.TZ") }}：</label>
      <select class="tz-select" style="width: 100%" v-model="tzId" name="tzId" id="tzId">
        <option disabled value="">{{ $t("lang.select") }}</option>
        <option class="tz-opt" v-for="(tz, index) in tz" :key="index" :label="tz" :value="tz">{{ tz }}</option>
      </select>
      <span slot="footer" class="dialog-footer">
        <el-button class="quit-btn" @click="timezoneDialogVisible = false">{{ $t("lang.cancel") }}</el-button>
        <el-button class="unbinding-btn" @click="setTimezone">{{ $t("lang.confirm") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ERR_OK, TIME_ZONE } from "api/config";
import {
  getLatestLesson,
  getCurrtWeekScheduledCount,
  lessonListByStatus
} from "api/course";
import { updateUserInfo } from "api/me";
import { getScrollHeight, getWindowHeight, getDocumentTop } from "utils/dom"
import timezones from "utils/timezones"
import moment from "moment-timezone";

export default {
  data() {
    return {
      userinfo: {
        name: 'name',
        avatarUrl: 'https://static.bingotalk.cn/users/avatars/5f02c265f0532.png'
      },
      scheduledCount: [
        {
          bookedNum: 0, // 已被预约 1V1
          openClassNum: 0, // 已被预约公开课
          teamNum: 0 // 已被预约 1Vn
        }
      ],
      listQuery: {
        week: 0,
        startWeek: "",
        endWeek: ""
      },
      finishedList: {
        lessonStatus: 0,
        pageNumber: 1,
        pageSize: 10
      },
      unfinishedList: {
        lessonStatus: 0,
        pageNumber: 1,
        pageSize: 10
      },
      finishedTotalPages: 0,
      unfinishedTotalPages: 0,
      unfinishedCourses: [],
      finishedCourses: [],
      timeZone: moment.tz.guess(),
      week: [],
      comingSoon: {},
      stuSimpInfo: [{
        avatar: ''
      }],
      isfinished: sessionStorage.getItem('isFinished') ? sessionStorage.getItem('isFinished') : '0',
      courseStartTime: null,
      showWeekTag: false,
      subjectType: '',
      language: '',
      prvFinishedCoursesStartTime: null,
      prvUnfinishedCoursesStartTime: null,
      timeZones: timezones,
      tz: '',
      tzId: '',
      timezoneDialogVisible: false
    };
  },
  computed: {
    allCourseCount() {
      return (
        this.scheduledCount.bookedNum +
        this.scheduledCount.openClassNum +
        this.scheduledCount.teamNum +
        this.scheduledCount.auditionClassNum
      )
    },
    unfinishedListLoad() {
      if (this.unfinishedList.pageNumber <= this.unfinishedTotalPages) {
        return true
      } else {
        return false
      }
    },
    finishedListLoad() {
      if (this.finishedList.pageNumber <= this.finishedTotalPages) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.initLang();
    this.setLanguage();
    this.getTimeZone();
    this.getUserInfo();
    this._getLatestLesson();
    this.getUnfinishedCourses();
    this.getFinishedCourses();
    this.getMore();
  },
  methods: {
    getTimeZone() {
      if (TIME_ZONE.indexOf(this.timeZone) > -1) {
        alert("No time zone");
      } else {
        moment.tz.setDefault(this.timeZone);
        this.getLocalWeek();
        this._getCurrtWeekScheduledCount();
      }
    },
    getLocalWeek() {
      this.week = [];
      for (let i = 0; i < 14; i++) {
        let day = moment()
          .tz(this.timeZone)
          .add(i, "days")
        this.week.push(day);
      }
      this.listQuery.startWeek = this.formatBeijingYYYYMMDDHHmmss(
        `${this.week[0].format("YYYY-MM-DD")} 00:00`
      );
      this.listQuery.endWeek = this.formatBeijingYYYYMMDDHHmmss(
        `${this.week[13].format("YYYY-MM-DD")} 23:59`
      );
    },
    getUserInfo() {
      this.$store
        .dispatch("GetUserInfo")
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.userinfo = response.data.data;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(() => {});
    },
    _getLatestLesson() {
      getLatestLesson()
        .then((response) => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.comingSoon = response.data.data;
              if (response.data.data) {
                this.stuSimpInfo = [{...response.data.data.stuSimpInfo[0]}];
              }
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch((e) => {
          console.log(e)
        });
    },
    _getCurrtWeekScheduledCount() {
      getCurrtWeekScheduledCount(this.listQuery)
        .then((response) => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.scheduledCount = response.data.data;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch((e) => {
          console.log(e)
        });
    },
    getUnfinishedCourses() {
      const list = {...this.unfinishedList, lessonStatus: 0}
      lessonListByStatus(list)
        .then((response) => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === 200) {
              let unfinishedCourses = response.data.data.content;
              for (let i = 0; i < unfinishedCourses.length; i++) {
                if (i === 0 && this.prvUnfinishedCoursesStartTime === null) {
                  this.$set(unfinishedCourses[0], `tag`, true);
                } else {
                  if (this.$utils.formatYYMMDD(unfinishedCourses[i].startTime) === this.prvUnfinishedCoursesStartTime) {
                    this.$set(unfinishedCourses[i], `tag`, false);
                  } else {
                    this.$set(unfinishedCourses[i], `tag`, true);
                  }
                }
                this.prvUnfinishedCoursesStartTime = this.$utils.formatYYMMDD(unfinishedCourses[i].startTime)
              }
              this.unfinishedCourses = this.unfinishedCourses.concat(unfinishedCourses);
              this.unfinishedTotalPages = response.data.data.totalPages;
              this.unfinishedList.pageNumber++
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch((e) => {
          console.log(e)
        });
    },
    getFinishedCourses() {
      const list = {...this.finishedList, lessonStatus: 1}
      lessonListByStatus(list)
        .then((response) => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === 200) {
              let finishedCourses = response.data.data.content;
              for (let i = 0; i < finishedCourses.length; i++) {
                if (i === 0 && this.prvFinishedCoursesStartTime === null) {
                  this.$set(finishedCourses[0], `tag`, true);
                } else {
                  if (this.$utils.formatYYMMDD(finishedCourses[i].startTime) === this.prvFinishedCoursesStartTime) {
                    this.$set(finishedCourses[i], `tag`, false);
                  } else {
                    this.$set(finishedCourses[i], `tag`, true);
                  }
                }
                this.prvFinishedCoursesStartTime = this.$utils.formatYYMMDD(finishedCourses[i].startTime)
              }
              this.finishedCourses = this.finishedCourses.concat(finishedCourses);
              this.finishedTotalPages = response.data.data.totalPages
              this.finishedList.pageNumber++
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch((e) => {
          console.log(e)
        });
    },
    getMore() {
      let that = this;
      window.addEventListener(
        "scroll",
        (function() {
          var timer;
          return function() {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function() {
              if (that.isfinished === '1') {
                if (getScrollHeight() - 5 <= getWindowHeight() + getDocumentTop()) {
                  if (that.finishedList.pageNumber <= that.finishedTotalPages) {
                    that.getFinishedCourses();
                  }
                }
              }
              if (that.isfinished === '0') {
                if (getScrollHeight() - 5 <= getWindowHeight() + getDocumentTop()) {
                  if (that.unfinishedList.pageNumber <= that.unfinishedTotalPages) {
                    that.getUnfinishedCourses();
                  }
                }
              }
            }, 500);
          };
        })()
      );
    },
    handleWeekTag(currentTime) {
      if (!this.courseStartTime) {
        this.courseStartTime = currentTime
        return true
      } else {
        if (currentTime === this.courseStartTime) {
          this.courseStartTime = currentTime
          return false
        } else {
          this.courseStartTime = currentTime
          return true
        }
      }
    },
    formatBeijingYYYYMMDDHHmmss(s) {
      if (s) {
        return moment
          .tz(s, this.timeZone)
          .tz("Asia/Shanghai")
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    initLang() {
      this.$store
        .dispatch("GetUserInfo")
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.subjectType = response.data.data.subjectType;
              this.timeZone = response.data.data.timezone ? response.data.data.timezone : "Asia/Shanghai";
              localStorage.setItem('timeZone', response.data.data.timezone)
              if (this.subjectType === 'ENGLISH') {
                let lang = 'en'
                this.$i18n.locale = lang;
                this.$store
                  .dispatch("setLanguage", lang)
                  .then(() => {
                    localStorage.setItem("language", lang);
                  })
                  .catch((e) => {
                    console.log(e)
                  });
              } else {
                let lang = 'cn'
                this.$i18n.locale = lang;
                this.$store
                  .dispatch("setLanguage", lang)
                  .then(() => {
                    localStorage.setItem("language", lang);
                  })
                  .catch((e) => {
                    console.log(e)
                  });
              }
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(() => {});
    },
    setLanguage() {
      this.language = this.$i18n.locale
    },
    handleTabs() {
      sessionStorage.setItem('isFinished', this.isfinished)
    },
    handleTZClick() {
      this.timezoneDialogVisible = true
    },
    setTimezone() {
      if (this.tzId && this.tz) {
        let newTzId = this.tzId
        this.timeZone = newTzId
        updateUserInfo({timezone: newTzId})
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              localStorage.setItem('timeZone', newTzId)
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
        this.timezoneDialogVisible = false
      } else {
        this.$message.error(this.$t('lang.tzNullTip'));
      }
    }
  }
};
</script>

<style lang="scss">
.home-mp {
  display: flex;
  flex-direction: column;
  max-width: 750px;
  padding: 0 4vw;
  min-height: 100vh;
  margin: 0 auto;
  font-size: 20px;
  background: #f9f9f9;

  .header {
    display: flex;
    align-items: center;
    margin: 28px 0 10px;

    .avatar {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      width: 48px;
      height: 48px;
      margin-right: 12px;
      border-radius: 50%;
      overflow: hidden;
      border: 1px solid #ffdd02;

      img {
        height: 48px;
        width: 48px;
      }
    }

    .teacher-name {
      font-size: 14px;
      font-weight: 500;
    }

    .booking-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 86px;
      height: 30px;
      margin-left: auto;
      padding: 0 4px;
      color: #4a4a4a;
      font-size: 12px;
      text-align: center;
      background: #ffda5c;
      border-radius: 5px;

      .booking-icon {
        width: 16px;
        height: 16px;
        margin-right: 4px;
        background: url(~assets/images/time.png) center center no-repeat;
        background-size: contain;
      }
    }
  }

  .card {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    padding: 10px;
    font-size: 14px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.07);
  }

  .scheduled-count-card {
    // justify-content: space-between;
    height: 80px;

    .count {
      font-size: 18px;
      color: #000000;
      font-weight: 500;
    }

    .all-scheduled {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      .text {
        height: 25px;
        line-height: 25px;
        font-size: 14px;
        font-weight: 500;
      }
      .count {
        height: 25px;
        line-height: 25px;
      }
    }

    .details-count {
      display: flex;
      justify-content: space-around;

      .text {
        margin-top: 6px;
        font-size: 12px;
        color: #4a4a4a;
      }

      & > * {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }

  .last-course-card {
    display: flex;
    flex-direction: column;

    .title {
      margin-bottom: 12px;
      font-size: 14px;
      font-weight: 500;
    }

    .course-info {
      display: flex;
      align-items: center;
      color: #000000;

      .stu-avatar {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 0 0 46px;
        height: 46px;
        width: 46px;
        margin-right: 8px;
        border-radius: 25px;
        overflow: hidden;
        background: pink;

        img {
          height: 46px;
          width: 46px;
        }
      }

      .course {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        height: 46px;

        .course-title {
          width: 220px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 15px;
          font-weight: 500;
        }
        .details {
          display: flex;
          align-items: center;

          .time {
            font-size: 12px;
          }

          .label {
            margin-left: auto;
            width: 56px;
            height: 22px;
            border-radius: 4px;
            text-align: center;
            line-height: 22px;
            background: #ffdd02;
          }

          .label-1vn {
            background: #87B2EC;
          }

          .label-open {
            background: #ED6D59;
          }
        }
      }
    }
  }

  .el-tabs__header {
    font-size: 16px;
    .el-tabs__nav {
      display: flex;
      justify-content: space-between;
      width: 200px;
      margin: 0 auto;
      float: none;

      .el-tabs__active-bar {
        background-color: #ffdd02;
      }

      .el-tabs__item {
        margin: 0;
        width: 100px;
        font-size: 15px;
        text-align: center;
        font-weight: 500;
        color: #9B9B9B;

        &.is-active {
          color: #000000;
        }
      }
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
  }

  .course-card {
    padding-top: 20px;
    margin-top: 6px;
    .courses {
      display: flex;
      flex-direction: column;
      color: #000000;
    }

    .courses-container {
      display: flex;
      align-items: center;
      padding: 10px 0;
      height: 46px;
      width: 100%;
      text-decoration: none;
      color: #000000;
    }

    .tag {
      width: 80px;
      height: 32px;
      margin: 15px 0;
      background: #EBEEF5;
      border-radius: 16px;
      color: #7F7F7F;
      font-size: 12px;
      line-height: 32px;
      text-align: center;
    }

    .label {
      flex: 0 0 50;
      width: 46px;
      height: 20px;
      margin-right: 10px;
      background: #FFDD02;
      border-radius: 4px;
      text-align: center;
      font-size: 12px;
      line-height: 20px;
      color: #000000;
    }

    .label-1vn {
      background: #87B2EC;
    }

    .label-open {
      background: #ED6D59;
    }

    .course-info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      flex: 1 1 200px;
      height: 46px;
    }

    .course-name {
      width: 200px;
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .time {
      font-size: 15px;
    }

    .arrow {
      width: 21px;
      height: 21px;
      background: url(~assets/images/Icon-arrow-right@2x.png) center center no-repeat;
      background-size: contain;

    }
  }

  .course-tab {
    position: sticky;
    top: 0;
    padding-top: 10px;
    background: #f9f9f9;
  }

  .no-course {
    display: flex;
    flex-direction: column;
    align-items: center;

    .no-course-img {
      margin-top: 100px;
      width: 70%;

      img {
        width: 100%;
      }
    }

    .text{
      margin: 26px 0 22px;
      color: #606266;
      font-size: 12px;
      text-align: center;
    }

    .booking-btn {
      margin-bottom: 60px;
      width: 76px;
      height: 30px;
      color: #4a4a4a;
      font-size: 12px;
      text-align: center;
      line-height: 30px;
      background: #ffda5c;
      border-radius: 6px;
    }
  }

  .border-btm {
    border-bottom: 1px solid rgba(151, 151, 151, 0.2);
  }

  .border-top {
    border-top: 1px solid rgba(151, 151, 151, 0.2);
  }

  .courses:last-child {
    .courses-container {
      border-bottom: none !important;
    }
  }

  .loader {
    height: 20px;
    margin: 6px auto 10px;
    font-size: 12px;
    line-height: 20px;
    color: gray;
    text-align: center;
  }

  .time-display {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #303133;

    .time {
      color: #303133;
    }
  }

  .wrong-timezone {
    padding: 0;
    outline: none;
    border: none;
    background: none;
    color: #303133;

    .el-icon-question {
      margin: 0 4px;
    }
  }

  .timzone-dialog {
    .el-dialog {
      border-radius: 12px;
      background: #ffffff;
    }

    .el-dialog__header {
      padding: 20px 0 0;
    }

    .el-dialog__body {
      .tip {
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #4A4A4A;
      }
    }

    .quit-btn,
    .unbinding-btn {
      border-radius: 0;
      width: 110px;
      height: 46px;
      border: none;
      border-radius: 5px;
      outline: none;
      color: #4A4A4A;
      background-color: #E4E7ED;
    }

    .unbinding-btn {
      border-radius: 5px;
      background: #FFE300;
    }
  }

  .tz-select {
    height: 34px;
    margin: 6px 0;
    padding: 4px 2px;
    border: 1px solid #696969;
    color: #4A4A4A !important;
    font-size: 14px;
    background: #fff;
    border-radius: 0;
    outline: none;
  }

  .tz-label {
    color: #4A4A4A;
    font-size: 12px;
  }

  .tz-opt {
    color: #4A4A4A;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/home-mp.vue